import {
    FETCH_GARANTIAS,
    LOADING_GARANTIAS,
} from './types';

import {
    fetchGarantiasApi,
} from '../api/axios';

export const fetchGarantias = (params) => async (dispatch) => {
  dispatch({ 
    type: LOADING_GARANTIAS, 
    payload: true 
});
  try {
    const garantias = await fetchGarantiasApi(params); 
    dispatch({ 
        type: FETCH_GARANTIAS, 
        payload: garantias });
    return garantias; 
  } catch (err) {
        throw err;
  } finally {
    dispatch({ 
        type: LOADING_GARANTIAS, 
        payload: false });
    }
};